<template>
  <a-row type="flex" align="middle" :gutter="[10, 40]" class="machine-learning-layer">
    <a-col flex="2" class="title">Слой {{ number }}</a-col>

    <a-col flex="5">
      <div>Тип слоя</div>
      <a-select v-model="data.type" size="large" @change="onTypeChange">
        <template v-for="type in types">
          <a-select-option :key="type" :value="type">{{ type }}</a-select-option>
        </template>
      </a-select>
    </a-col>

    <a-col v-if="data.type === types.DENSE" flex="5">
      <div>Количество нейронов</div>
      <a-input-number v-model="data.units" size="large" @change="emitInput" />
    </a-col>

    <a-col v-else-if="data.type === types.ACTIVATION" flex="5">
      <div>Функция активации</div>
      <a-select v-model="data.activation" size="large" @change="emitInput">
        <template v-for="funcName in activationFunctions">
          <a-select-option :key="funcName" :value="funcName">{{ funcName }}</a-select-option>
        </template>
      </a-select>
    </a-col>

    <a-col v-else-if="data.type === types.DROPOUT" flex="5">
      <div>Доля исключений</div>
      <a-input-number
        v-model="data.rate"
        :min="0"
        :max="100"
        :step="1"
        size="large"
        @change="emitInput"
      />
    </a-col>

    <a-col flex="20px" style="align-self: self-end">
      <a-button size="large" class="btn-remove" @click="$emit('remove')">–</a-button>
    </a-col>
  </a-row>
</template>

<script>
const types = Object.freeze({
  DENSE: 'Dense',
  ACTIVATION: 'Activation',
  DROPOUT: 'Dropout',
});

const activationFunctions = Object.freeze([
  'relu',
  'sigmoid',
  'softmax',
  'softplus',
  'softsign',
  'tanh',
  'selu',
  'elu',
  'exponential',
]);

const defaultData = Object.freeze({
  type: types.DENSE,
  units: 0,
  activation: '',
  rate: 0,
});

export default {
  name: 'MachineLearningLayer',

  props: {
    number: {
      type: Number,
      default: 0,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    types,
    activationFunctions,
    data: {
      ...defaultData,
    },
  }),

  watch: {
    value() {
      this.initData();
    },
  },

  mounted() {
    this.initData();
  },

  methods: {
    initData() {
      this.data = {
        ...this.data,
        ...(this.value.type ? this.value : defaultData),
      };
    },

    onTypeChange(type) {
      this.data = { ...this.data, ...defaultData, type };

      if (type === types.ACTIVATION) {
        this.data.activation = activationFunctions[0];
      }

      this.emitInput();
    },

    emitInput() {
      this.$emit('input', this.data);
    },
  },
};
</script>

<style lang="scss">
.machine-learning-layer {
  .title {
    align-self: self-end;
    margin-bottom: 8px;
  }

  .btn-remove {
    padding: 0 7px;
    background: #acbed7;
    color: #fff;
    border: 0;
  }
}
</style>
